export const iconFontAwesomeConstructionHelmetSafety = (
	<i className="fa-solid fa-helmet-safety"></i>
);
